/**
 * @author liqiuqi
 * @date 2022 2022/6/28 14:14
 */
/** 订阅 **/
const subscribe = {
  namespaced: true,
  state: {
    recommendSubscribe: null, // 推荐订阅
    subscribeVersionUserSetting: 1, // 0：老版本  1：新版本
    biddingInfoSubscribeList: [], // 标讯订阅器列表
    constrProjectSubscribeList: [], // 拟在建订阅器列表
    examineProjectSubscribeList: [], // 审批订阅器列表
    purchaseIntentionSubscribeList: [],
    currentSubscribe: {
      // type, // 订阅器模式 1 标讯普通 2 标讯专业 3 智能订阅器模式 4审批 5拟在建
    }, // 当前订阅器（不区分标讯 拟建 审批）
    currentSubscribeFilterParams: {
      // areaIds,
      // beginAmount,
      // biddingType,
      // businessIds,
      // contentIdList,
      // dateType,
      // endAmount,
      // endTime,
      // exportKeyword,
      // exportSource,
      // exportType,
      // fieldType,
      // fundsSourceList,
      // hasAgent,
      // hasAnnex,
      // hasLinkName,
      // hasPhone,
      // hitWord,
      // keyword,
      // noticeSegmentTypeStr,
      // onlyCompanyMonitor,
      // page,
      // progIdAndNoticeSegmentTypeMaps,
      // progIds,
      // purchasingUnit,
      // purchasingUnitIdList,
      // registrationStatus,
      // rows,
      // sortType,
      // startTime,
      // subscribeId,
      // subscribeIndex,
      // subscribeType,
      // summaryType,
      // tenderOrBidderName,
      // threeClassifyTagStr,
    }, // 当前订阅器 - 订阅信息 - 筛选条件
    currentSubscribeViewType: 1, //当前视图模式是什么 1：公告模式，2，商情模式
  },
  getters: {
    recommendSubscribe: (state) => state.recommendSubscribe,
    biddingInfoSubscribeList: (state) => state.biddingInfoSubscribeList,
    subscribeVersionUserSetting: (state) => state.subscribeVersionUserSetting,
    constrProjectSubscribeList: (state) => state.constrProjectSubscribeList,
    examineProjectSubscribeList: (state) => state.examineProjectSubscribeList,
    purchaseIntentionSubscribeList: (state) => state.purchaseIntentionSubscribeList,
    currentSubscribe: (state) => state.currentSubscribe,
    currentSubscribeFilterParams: (state) => state.currentSubscribeFilterParams,
    currentSubscribeViewType: (state) => state.currentSubscribeViewType,
  },
  mutations: {
    // 更新推荐订阅信息
    updateRecommendSubscribe(state, recommendSubscribe) {
      state.recommendSubscribe = recommendSubscribe;
    },
    updateSubscribeVersionUserSetting(state, subscribeVersionUserSetting) {
      state.subscribeVersionUserSetting = subscribeVersionUserSetting;
    },
    updateBiddingInfoSubscribeList(state, biddingInfoSubscribeList) {
      state.biddingInfoSubscribeList = biddingInfoSubscribeList;
    },
    updateConstrProjectSubscribeList(state, constrProjectSubscribeList) {
      state.constrProjectSubscribeList = constrProjectSubscribeList;
    },
    updateExamineProjectSubscribeList(state, examineProjectSubscribeList) {
      state.examineProjectSubscribeList = examineProjectSubscribeList;
    },
    updatePurchaseIntentionSubscribeList(state, purchaseIntentionSubscribeList) {
      state.purchaseIntentionSubscribeList = purchaseIntentionSubscribeList;
    },
    updateCurrentSubscribe(state, currentSubscribe) {
      state.currentSubscribe = currentSubscribe;
    },
    updateCurrentSubscribeFilterParams(state, currentSubscribeFilterParams) {
      // console.log("请求参数", JSON.stringify(currentSubscribeFilterParams));
      state.currentSubscribeFilterParams = currentSubscribeFilterParams;
    },
    updateCurrentSubscribeViewType(state, currentSubscribeViewType) {
      state.currentSubscribeViewType = currentSubscribeViewType;
    },
  },
  actions: {},
};
export default subscribe;
